import React, { createContext, useContext } from 'react'

import { initialState } from './reducer'

import {AppAction,CvDataStateType} from '../types'

type StateContextType={
    state:CvDataStateType,
    dispatch:React.Dispatch<AppAction>
}

export const StateContext = createContext<StateContextType>({state:initialState,dispatch:()=>undefined})


export const useStateProviderValue = () => useContext(StateContext)

